import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphqlRequest } from '@/services/deployment/client';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { REACTIVATE_ORG_USER_MUTATION } from '@/services/org-admin';
import type { OrgAdminUser } from '@/services/org-admin';

interface ReactivateOrgUserResponse {
  reactivateOrgUser: OrgAdminUser;
}

export function useReactivateOrgMember() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: async (userId: string) => {
      const response = await graphqlRequest<ReactivateOrgUserResponse>(REACTIVATE_ORG_USER_MUTATION, {
        input: { organizationId: orgId, userId },
      });
      return response.reactivateOrgUser;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['org-members', orgId] });
    },
    // Caller already shows its own success/error toast — suppress the global one.
    meta: { silent: true },
  });
}
